module.exports = __webpack_public_path__ + "static/media/idouKashishiji.53425498.png";